import React, { Fragment, useMemo, useState } from 'react';
import { PageTitle } from '../../../components/PageTitle';
import { useTranslation } from 'react-i18next';
import { Tab, TabControl } from '../../../components/tabs';
import { ClientsTab } from './tabs/ClientsTab';
import { ContactsTab } from './tabs/ContactsTab';
import { FilterFields } from '../../../components/ManagedDataTable/interfaces';
import { useGetGroupList } from '../../../reactQuery/groups';
import { useGetAgentsList } from '../../../reactQuery/Agents/agents';
import { useGetproductsList } from '../../../reactQuery/products';
import { useGetClientsList } from '../../../reactQuery/clients';
import { useAuth } from '../../../context/AuthProvider';
import { useGetContactsList } from '../../../reactQuery/contacts';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ApartmentIcon from '@mui/icons-material/Apartment';

export const RelationshipManagement: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState<number>(0);

  const { auth } = useAuth();

  const { data: groupList } = useGetGroupList();
  const { data: agentsList } = useGetAgentsList();
  const { data: productsList } = useGetproductsList();
  const { data: clientsList } = useGetClientsList();
  const { data: contactsList } = useGetContactsList();

  const isAdmin = auth?.user && auth.user.isAdmin === true;

  const defaultFilter = useMemo((): FilterFields => {
    if (!isAdmin && auth?.user) {
      return [
        {
          field: 'responsible_agents',
          values: [auth.user.id],
        },
      ];
    }

    return [];
  }, [auth?.user]);

  return (
    <Fragment>
      <PageTitle
        title={t('clients:relationshipManagement.title')}
        subTitle={t('clients:relationshipManagement.subTitle')}
        space
      />

      <TabControl value={currentTab} onChange={(value) => setCurrentTab(value)}>
        <Tab
          label={t('clients:relationshipManagement.tabs.clients')}
          icon={<ApartmentIcon />}
        />
        <Tab
          label={t('clients:relationshipManagement.tabs.contacts')}
          icon={<ContactPhoneIcon />}
        />
      </TabControl>

      <ClientsTab
        value={currentTab}
        index={0}
        groupList={groupList}
        agentsList={agentsList}
        productsList={productsList}
        clientsList={clientsList}
        defaultFilter={defaultFilter}
        isAdmin={isAdmin || false}
      />
      <ContactsTab
        value={currentTab}
        index={1}
        agentsList={agentsList}
        contactsList={contactsList}
        productsList={productsList}
        defaultFilter={defaultFilter}
        isAdmin={isAdmin || false}
      />
    </Fragment>
  );
};
